import {
  HighlightsController,
  type HighlightsControllerOptions
} from '@databases/highlights';

import {
  subscribeToTimelineHighlightsGeometryChanges,
  TimelineHighlightsGeometryResolver
} from './timeline-highlights-geometry.ts';

class TimelineHighlightsController extends HighlightsController {
  readonly #unsubscribeGeometryChanges: VoidFunction;

  constructor(options: Pick<HighlightsControllerOptions, 'id'>) {
    super(new TimelineHighlightsGeometryResolver(), options);

    this.#unsubscribeGeometryChanges = subscribeToTimelineHighlightsGeometryChanges(
      (adapter) => {
        if (adapter) {
          this.mount(adapter.getResizeObserveTarget());
        }

        this.redrawAll();
      }
    );
  }

  public override dispose(): void {
    this.#unsubscribeGeometryChanges();
    super.dispose();
  }
}

export function createTimelineHighlightsController(
  options: Pick<HighlightsControllerOptions, 'id'>
): HighlightsController {
  return new TimelineHighlightsController(options);
}
